export default __webpack_public_path__ + "static/media/team4.51f4e099.png";